import { render, staticRenderFns } from "./NANOFountainDescription.vue?vue&type=template&id=a511ad76&scoped=true&"
import script from "./NANOFountainDescription.vue?vue&type=script&lang=js&"
export * from "./NANOFountainDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a511ad76",
  null
  
)

export default component.exports